import { useEffect } from 'react';

export interface FirebaseBgUpdateProps {
  handleGetNotifications: () => void;
}

export const useFirebaseBgUpdate = ({ handleGetNotifications }: FirebaseBgUpdateProps) => {
  useEffect(() => {
    const channel = new BroadcastChannel('indexeddb-updates');
    channel.onmessage = (event) => {
      if (event.data.type === 'added') {
        handleGetNotifications();
      }
    };

    return () => {
      channel.close();
    };
  }, []);
};
